export const flowData = [
    {
        style: "bg-blue-200 w-40 my-2 py-2 mx-2 rounded-md cursor-grab shadow-lg",
        type: "nodeA",
        text: "Trigger",
        title: "Drag this Trigger"
    },
    {
        style: "bg-blue-200 w-40 my-2 py-2 mx-2 rounded-md cursor-grab shadow-lg",
        type: "nodeB",
        text: "Action",
        title: "Drag this Action"
    },
    {
        style: "bg-blue-200 w-40 my-2 py-2 mx-2 rounded-md cursor-grab shadow-lg",
        type: "nodeC",
        text: "Condition",
        title: "Drag this Condition"
    },
];